// extracted by mini-css-extract-plugin
export default {"radio":"cpgLT"};